import { siteId as defaultSiteId } from "Selectors/DashboardSelector"
import { getStartDate, getEndDate } from 'Utils/MomentHelpers';

const create = (api) => {
  const getBatteryWithLowHealthCard = (startDate = getStartDate(), endDate = getEndDate(), siteId = defaultSiteId, batteryPercentage = 75) => {
    return api.get(`dashboard/batteryhealth/dashboardlowhealth/${siteId}?startDate=${startDate}&endDate=${endDate}&batteryPercentage=${batteryPercentage}`)
  }

  const getBatteryWithLowHealthDetails = (startDate = getStartDate(), endDate = getEndDate(), siteId = defaultSiteId, batteryPercentage = 75, params = {}, pageNumber = 1, pageSize = 100) => {
    const query = (params.searchTerm === null || params.searchTerm === undefined) ? `&query=` : `&query=${params.searchTerm}`
    const sort = (params.sort === null || params.sort === undefined) ? `&sort=` : `&sort=${params.sort}`
    const directionSort = (params.directionSort === null || params.directionSort === undefined) ? `&directionSort=` : `&directionSort=${params.directionSort}`
    const language = (params.language === null || params.language === undefined) ? `&language=en-US` : `&language=${params.language}`
    return api.get(`/dashboard/batteryhealth/lowhealth/details/${siteId}?startDate=${startDate}&endDate=${endDate}&batteryPercentage=${batteryPercentage}&includeChildren=true&pageNumber=${pageNumber}&pageSize=${pageSize}`+ `${query}` + `${sort}` + `${directionSort}` + `${language}`)

  }

  const getExportDeviceCVSFile = (siteId = defaultSiteId, payload = {}, params = {}, startDate = getStartDate(), endDate = getEndDate()) =>
          api.post(`/dashboard/exportfiles/${siteId}?startDate=${startDate}&endDate=${endDate}`, payload, { params });
   
  return {
    getBatteryWithLowHealthCard,
    getBatteryWithLowHealthDetails,
    getExportDeviceCVSFile
  }
}

export default {
  create
}